/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Table Styling
   ========================================================================== */
.o-table__cell--right-align {
  text-align: right;
}

.o-table-wrapper--scrolling {
  box-sizing: border-box;
  overflow-y: hidden;
}
.o-table-wrapper--scrolling table {
  border: 1px solid var(--gray-40);
}
.o-table-wrapper--scrolling table > tbody > tr:nth-child(even) > th, .o-table-wrapper--scrolling table > tbody > tr:nth-child(even) > td {
  background: var(--gray-5);
}

@media only all and (min-width: 37.5625em) {
  .o-table--striped > tbody > tr:nth-child(even) > th, .o-table--striped > tbody > tr:nth-child(even) > td {
    background: var(--gray-5);
  }
}
@media only screen and (max-width: 600px) {
  .o-table {
    width: 100%;
  }
  .o-table--striped tr:nth-child(even) > th, .o-table--striped tr:nth-child(even) > td {
    background: var(--white);
  }
  .o-table--stack-on-small {
    border-top: 1px solid var(--gray-40);
  }
  .o-table--stack-on-small tr,
  .o-table--stack-on-small td,
  .o-table--stack-on-small [data-display-table=row],
  .o-table--stack-on-small [data-display-table=cell] {
    display: block;
  }
  .o-table--stack-on-small th,
  .o-table--stack-on-small td,
  .o-table--stack-on-small [data-display-table=cell] {
    padding-right: 0;
    padding-left: 0;
    width: 100%;
  }
  .o-table--stack-on-small > thead,
  .o-table--stack-on-small [data-display-table=thead] {
    display: none;
  }
  .o-table--stack-on-small td[data-label]::before {
    display: block;
    margin-top: 0;
    margin-bottom: 0.3125em;
    content: attr(data-label);
    line-height: 1.83333333;
    font-size: 0.875em;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  .o-table--stack-on-small td:last-child,
  .o-table--stack-on-small [data-display-table=cell]:last-child {
    margin-bottom: 1.875em;
  }
  .o-table--entry-header-on-small > tbody td:first-child {
    padding-bottom: 0.75em;
    border-bottom: 1px solid var(--gray);
    margin-bottom: 0.625em;
    margin-top: 0;
    background-color: var(--gray-5);
    font-size: 1.125em;
    font-weight: 400;
    line-height: 1.22222222;
  }
  .o-table--entry-header-on-small > tbody td:first-child::before {
    display: none;
  }
  .o-table--entry-header-on-small > tbody > tr {
    border-bottom: none;
    margin-bottom: 1.875em;
  }
}